import { render } from "./DamageReported.vue?vue&type=template&id=009d5d7c&scoped=true&ts=true"
import script from "./DamageReported.vue?vue&type=script&lang=ts"
export * from "./DamageReported.vue?vue&type=script&lang=ts"

import "./DamageReported.vue?vue&type=style&index=0&id=009d5d7c&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009d5d7c"]])

export default __exports__